import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthCallback from "./pages/AuthCallback";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import PublicFunnel from "./pages/PublicFunnel";
import PublicLanding from "./pages/PublicLanding";
import Admin from "./pages/Admin";
import PinCampaign from "./pages/PinCampaign";
import { QuienesSomos, AvisoPrivacidad, EliminacionDatos, Terminos } from "./pages/Legal";
import DashboardLayout from "./components/DashboardLayout";
import Overview from "./pages/dashboard/Overview";
import CompanyProfile from "./pages/dashboard/CompanyProfile";
import Companies from "./pages/dashboard/Companies";
import Generator from "./pages/dashboard/Generator";
import GuidedCampaigns from "./pages/dashboard/GuidedCampaigns";
import Funnels from "./pages/dashboard/Funnels";
import Leads from "./pages/dashboard/Leads";
import Resources from "./pages/dashboard/Resources";
import Plans from "./pages/dashboard/Plans";
import PinsForSale from "./pages/dashboard/PinsForSale";
import SocialConnect from "./pages/dashboard/SocialConnect";
import LandingBuilder from "./pages/dashboard/LandingBuilder";
import BeforeYouStart from "./pages/dashboard/BeforeYouStart";
import AiMinutes from "./pages/dashboard/AiMinutes";
import AiCalls from "./pages/dashboard/AiCalls";
import FreePublishing from "./pages/dashboard/FreePublishing";
import RenalifeMaterials from "./pages/dashboard/RenalifeMaterials";
import RenalifeLanding from "./pages/RenalifeLanding";
import RenalifeMatching from "./pages/RenalifeMatching";
import RenalifeInfinito from "./pages/RenalifeInfinito";
import RenalifeFundador from "./pages/RenalifeFundador";
import RenalifeProducto from "./pages/RenalifeProducto";
import RenalifeTema from "./pages/RenalifeTema";
import RenalifeCalendar from "./pages/dashboard/RenalifeCalendar";
import RenalifeTikTok from "./pages/dashboard/RenalifeTikTok";
import RenalifeMultinivel from "./pages/dashboard/RenalifeMultinivel";
import Academia from "./pages/dashboard/Academia";
import AcademiaLumi from "./pages/dashboard/AcademiaLumi";
import MultinivelLanding from "./pages/MultinivelLanding";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="w-10 h-10 border-4 border-purple-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  // Invitado con PIN: primero completa nombre + WhatsApp en /campana-pin; luego entra al panel completo.
  if (user?.role === "pin_guest" && !user?.whatsapp) return <Navigate to="/campana-pin" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/campana-pin" element={<PinCampaign />} />
      <Route path="/quienes-somos" element={<QuienesSomos />} />
      <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
      <Route path="/eliminacion-datos" element={<EliminacionDatos />} />
      <Route path="/terminos" element={<Terminos />} />
      <Route path="/f/:slug" element={<PublicFunnel />} />
      <Route path="/p/:slug" element={<PublicLanding />} />
      <Route path="/r/:slug" element={<RenalifeLanding />} />
      <Route path="/r/:slug/matching" element={<RenalifeMatching />} />
      <Route path="/r/:slug/infinito" element={<RenalifeInfinito />} />
      <Route path="/r/:slug/fundador" element={<RenalifeFundador />} />
      <Route path="/r/:slug/producto/:pid" element={<RenalifeProducto />} />
      <Route path="/r/:slug/tema/:tid" element={<RenalifeTema />} />
      <Route path="/m/:slug" element={<MultinivelLanding />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Overview />} />
        <Route path="antes-de-empezar" element={<BeforeYouStart />} />
        <Route path="perfil" element={<CompanyProfile />} />
        <Route path="empresas" element={<Companies />} />
        <Route path="generador" element={<Generator />} />
        <Route path="campanas" element={<GuidedCampaigns />} />
        <Route path="landing/:gcId" element={<LandingBuilder />} />
        <Route path="embudos" element={<Funnels />} />
        <Route path="redes" element={<SocialConnect />} />
        <Route path="prospectos" element={<Leads />} />
        <Route path="recursos" element={<Resources />} />
        <Route path="planes" element={<Plans />} />
        <Route path="minutos-ia" element={<AiMinutes />} />
        <Route path="llamadas-ia" element={<AiCalls />} />
        <Route path="publicaciones-gratis" element={<FreePublishing />} />
        <Route path="materiales-renalife" element={<RenalifeMaterials />} />
        <Route path="multinivel" element={<RenalifeMultinivel />} />
        <Route path="academia" element={<Academia />} />
        <Route path="academia-lumi" element={<AcademiaLumi />} />
        <Route path="calendario-renalife" element={<RenalifeCalendar />} />
        <Route path="tiktok-renalife" element={<RenalifeTikTok />} />
        <Route path="pins" element={<PinsForSale />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" theme="dark" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
